// extracted by mini-css-extract-plugin
export default {"cls1":"EF2f_eS1ZC1gWmxxsIEt","cls2":"qoTBke75_YX5QkpFYxS4 EF2f_eS1ZC1gWmxxsIEt","isPhone":"bR0zWg5jvu1n8CkZMvXo"};